import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withTranslation } from 'react-i18next'

import { fetchLeaderBoard, setFilterByRange } from 'store/entities/feed/actions'
import { getFeedFilterByTeam, getFeedFilterByRange } from 'store/entities/feed/selectors'
import FeedFilterByRange from './FeedFilterByRange'

const mapStateToProps = createStructuredSelector({
  byTeam: getFeedFilterByTeam,
  byRange: getFeedFilterByRange,
})

const mapDispatchToProps = {
  fetchLeaderBoard,
  setFilterByRange,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FeedFilterByRange))
